export const SELECTORS = {
  GET_TICKET_FILTER_SELECTOR: 'GET_TICKET_FILTER_SELECTOR',
  IS_EXTERNAL_USER: 'IS_EXTERNAL_USER',
  IS_TP_COUNCIL: 'IS_TP_COUNCIL',
  GET_USER_CHAT_ROLES: 'GET_USER_CHAT_ROLES',
  GET_LOGINED_USER_CLINICS: 'GET_LOGINED_USER_CLINICS',
  GET_CURRENT_BRANCHES: 'GET_CURRENT_BRANCHES'
};
